import React from "react";

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

/** Two edges and a box spaced between them; turned, it spaces across. */
export const DistributeVerticallyIcon = (
  props: IconProps,
): React.JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    data-testid="DistributeIcon"
    {...props}
  >
    <path d="M2 3h20v2H2zm0 16h20v2H2zm4-9h12v4H6z" />
  </svg>
);

export const DistributeHorizontallyIcon = ({
  style,
  ...props
}: IconProps): React.JSX.Element => (
  <DistributeVerticallyIcon
    {...props}
    style={{ ...style, transform: "rotate(90deg)" }}
  />
);
